'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOAPORTAL_UNSET = exports.HOAPORTALS_SET = exports.HOAPORTAL_SET = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchHoaPortal = fetchHoaPortal;
exports.fetchHoaPortals = fetchHoaPortals;
exports.fetchHoaPortalIfNeeded = fetchHoaPortalIfNeeded;

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOAPORTAL_SET = exports.HOAPORTAL_SET = 'HOAPORTAL_SET';
var HOAPORTALS_SET = exports.HOAPORTALS_SET = 'HOAPORTALS_SET';
var HOAPORTAL_UNSET = exports.HOAPORTAL_UNSET = 'HOAPORTAL_UNSET';

var API_URL = 'https://api.mybuildercloud.com/api/v2/hoa-portal';

var isServer = !!process.env.REACT_APP_SERVER;

function fetchHoaPortal() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var _getState, token, _ref2, portal, _ref3, residents;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), token = _getState.user.token;

              if (token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.hoaPortal', API_URL) + '/portal',
                method: 'GET'
              });

            case 6:
              _ref2 = _context.sent;
              portal = _ref2.data;
              _context.next = 10;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.hoaPortal', API_URL) + '/residents',
                method: 'GET'
              });

            case 10:
              _ref3 = _context.sent;
              residents = _ref3.data;


              dispatch({
                type: HOAPORTAL_SET,
                portal: (0, _extends3.default)({}, portal, {
                  residents: residents._items
                })
              });
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](3);

              dispatch({
                type: HOAPORTAL_UNSET
              });
              console.error('Error getting portal', _context.t0);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 15]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchHoaPortals() {
  var _this2 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var builder, _ref5, portals;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              builder = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _context2.prev = 1;
              _context2.next = 4;
              return (0, _axios2.default)({
                headers: {},
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.hoaPortal', API_URL) + '/portals',
                method: 'POST',
                data: {
                  builder: builder
                }
              });

            case 4:
              _ref5 = _context2.sent;
              portals = _ref5.data;


              dispatch({
                type: HOAPORTALS_SET,
                portals: portals
              });
              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);

              dispatch({
                type: HOAPORTAL_UNSET
              });
              console.error('Error getting portals', _context2.t0);

            case 13:
              dispatch(fetchHoaPortal());

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 9]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function shouldFetchHoaPortal(_ref6) {
  var hoaPortal = _ref6.hoaPortal,
      token = _ref6.user.token;
  var fetched = hoaPortal.fetched,
      fetchedPortals = hoaPortal.fetchedPortals;


  if (isServer) {
    return false;
  }if (token && !fetched || !fetchedPortals) {
    return true;
  } else if (hoaPortal.isFetching) {
    return false;
  }

  return hoaPortal.didInvalidate;
}

function fetchHoaPortalIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchHoaPortal(getState())) {
      return dispatch(fetchHoaPortals());
    }
    return null;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/HoaPortal/actions.js
// module id = 491
// module chunks = 0